import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import { setSurvey } from "../../redux/surveySlice";
import CurrentUsesLabel from "./CurrentUsesLabel";

const UseModal = (props) => {
  const [use, setUse] = useState("");
  const dispatch = useDispatch();

  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="customModal modalUse"
      >
        <div className="modalHeader">
          <div className="media-body">
            <h3>Use</h3>
            <p>What is the Current use?</p>
          </div>
          <button
            className="cta-text"
            onClick={() => {
              dispatch(setSurvey({ field: "currentUse", value: "" }));
              props.onHide();
            }}
          >
            Cancel
          </button>
        </div>
        <div className="modalBody">
          <CurrentUsesLabel
            setUse={(e) =>
              dispatch(setSurvey({ field: "currentUse", value: e }))
            }
          />
          <div className="text-end mt-4">
            <button className="btn cta-primary px-4" onClick={props.onHide}>
              Confirm
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UseModal;
